import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiAlertTriangle, FiCalendar, FiCheckCircle, FiChevronRight, FiClock, FiFileText } from 'react-icons/fi';
import styles from '../Dashboard.module.css';
import { getStatusIconClass } from './dashboardSummaryHelpers';

// The "My Assignments" hero summary card. Extracted VERBATIM from
// DashboardSummaryCards' render.
export default function AssignmentsSummaryCard({
  assignmentSummary, formatDueDate, getAssignmentStatus, handleAssignmentClick, loaded, recentAssignments,
}) {
  return (
    <motion.div
      className={`${styles.summaryCard} ${styles.heroCard}`}
      initial={false}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.summaryHeader}>
        <h3 className={styles.summaryTitle}>
          <FiFileText size={20} />
          My Assignments
        </h3>
        <Link
          to="/assignments"
          className={styles.viewAllButton}
        >
          View All
        </Link>
      </div>
      <div className={styles.summaryContent}>
        <div className={styles.summaryStats}>
          {assignmentSummary.dueSoon > 0 && (
            <div className={`${styles.summaryStatPill} ${styles.dueSoonChip}`}>
              <span className={styles.summaryStatValue}>{assignmentSummary.dueSoon}</span>
              <span className={styles.summaryStatLabel}>Open</span>
            </div>
          )}
          <div className={`${styles.summaryStatPill} ${styles.completedChip}`}>
            <span className={styles.summaryStatValue}>{assignmentSummary.completed}</span>
            <span className={styles.summaryStatLabel}>Completed</span>
          </div>
          {assignmentSummary.overdue > 0 && (
            <div className={`${styles.summaryStatPill} ${styles.overdueChip}`}>
              <span className={styles.summaryStatValue}>{assignmentSummary.overdue}</span>
              <span className={styles.summaryStatLabel}>Overdue</span>
            </div>
          )}
        </div>
        <div className={styles.summaryItems}>
          {recentAssignments.length > 0 ? (
            recentAssignments.map((assignment, index) => {
              const status = getAssignmentStatus(assignment);
              const iconStatus = assignment.is_extra_credit ? 'extra-credit' : status;
              const dueDateText = formatDueDate(assignment.due_date, assignment);
              // For weekly assignments, include week_number in key to ensure uniqueness
              const uniqueKey = assignment.allow_weekly_submissions && assignment.week_number
                ? `${assignment.id}-week-${assignment.week_number}`
                : assignment.id || `assignment-${index}`;
              return (
                <div
                  key={uniqueKey}
                  className={styles.listRow}
                  onClick={() => handleAssignmentClick(assignment.id, assignment.week_number)}
                  role="button"
                  tabIndex={0}
                  aria-label={`${(assignment.allow_weekly_submissions && assignment.week_number ? `Week ${assignment.week_number}: ` : '') + assignment.title}, due ${dueDateText}`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleAssignmentClick(assignment.id);
                    }
                  }}
                >
                  <div className={getStatusIconClass(iconStatus)}>
                    {status === 'completed' ? <FiCheckCircle size={16} /> :
                     status === 'overdue' ? <FiAlertTriangle size={16} /> :
                     <FiClock size={16} />}
                  </div>
                  <div className={styles.rowMain}>
                    <div className={styles.summaryItemTitle}>{(assignment.allow_weekly_submissions && assignment.week_number ? `Week ${assignment.week_number}: ` : '') + assignment.title}</div>
                  <div className={styles.rowMeta}>
                      {dueDateText ? (
                        <>
                          <FiCalendar size={12} />
                          <span><strong>Due:</strong> {dueDateText}</span>
                        </>
                      ) : (
                        <span>Extra credit</span>
                      )}
                    </div>
                  </div>
                  <div className={styles.rowChevron}>
                    <FiChevronRight size={16} />
                  </div>
                </div>
              );
            })
          ) : loaded ? (
            <div className={styles.emptySummary}>
              <FiFileText />
              <p>You're all caught up.</p>
            </div>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
}
